module.exports = __webpack_public_path__ + "static/media/walkBackground.b1f6a776.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/CommitView/Walk/walkBackground.svg
// module id = 915
// module chunks = 0